export class PaymentsService {
  ENDPOINTS = {
    setCookie: "/security/setCookie",
    anonymousCheckoutView: "/payments/anonymousCheckoutView",
    checkoutView: "/payments/checkoutView",
    subscriptionPortal: "/payments/subscriptionPortal"
  };
  constructor(httpClient, config) {
    this.debug = config.debug;
    this.httpClient = httpClient;
    this.apiHost = config.apiHost;
  }
  async redirectToAnonymousCheckoutView() {
    await this._setSecureCookie();
    window.location.href = `${this.apiHost}${this.ENDPOINTS.anonymousCheckoutView}`;
  }
  async redirectToCheckoutView() {
    await this._setSecureCookie();
    window.location.href = `${this.apiHost}${this.ENDPOINTS.checkoutView}`;
  }
  async redirectToSubscriptionPortal() {
    await this._setSecureCookie();
    window.location.href = `${this.apiHost}${this.ENDPOINTS.subscriptionPortal}`;
  }
  async _setSecureCookie() {
    await this.httpClient.post(`${this.apiHost}${this.ENDPOINTS.setCookie}`, {}, {
      baseURL: this.apiHost,
      withCredentials: true
    });
  }
}